import React from "react";
import type {
	CreateProps,
	EditProps,
	ListProps,
	Record,
	ToolbarProps,
} from "react-admin";
import {
	List,
	Datagrid,
	TextField,
	Create,
	Edit,
	BooleanField,
	SimpleForm,
	TextInput,
	EditButton,
	NumberInput,
	BooleanInput,
	required,
	regex,
	SaveButton,
	Toolbar,
	FunctionField,
} from "react-admin";

function PaletteColourList(props: ListProps) {
	return (
		<List
			{...props}
			bulkActionButtons={false}
			pagination={false}
			title="Palette colours"
		>
			<Datagrid>
				<TextField source="id" sortable={false} />
				<FunctionField
					source="colour"
					sortable={false}
					render={(record?: Record) => {
						if (!record) {
							return null;
						}

						const value = record.colour;
						return (
							<div
								style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
							>
								<div style={{ background: value, width: 20, height: 20 }} />{" "}
								{value}
							</div>
						);
					}}
				/>
				<FunctionField
					source="symbol"
					sortable={false}
					render={(record?: Record) => {
						if (!record || !record.symbolSvgContent) {
							return <em>-</em>;
						}

						return (
							<div
								style={{ width: 20, height: 20, fill: record.colour }}
								dangerouslySetInnerHTML={{ __html: record.symbolSvgContent }}
							/>
						);
					}}
				/>
				<BooleanField source="enabled" sortable={false} />
				<EditButton />
			</Datagrid>
		</List>
	);
}

const validateColour = [
	required(),
	regex(/^#[0-9a-fA-F]{6}$/, "Colour must be in hex format (e.g. #123456)"),
];

function PaletteColourCreate(props: CreateProps) {
	return (
		<Create {...props}>
			<SimpleForm>
				<NumberInput
					source="id"
					validate={[
						required(),
						regex(/^#[1-9]{1}[0-9]*?$/, "Id must be an integer"),
					]}
				/>
				<TextInput source="colour" validate={validateColour} />
				<TextInput
					source="symbolSvgContent"
					required={false}
					multiline
					minRows={5}
					helperText="WARNING: For developers only. Staff do not change"
					disabled
				/>
				<BooleanInput source="enabled" defaultValue={false} />
			</SimpleForm>
		</Create>
	);
}

function EditToolbar(props: ToolbarProps) {
	return (
		<Toolbar {...props}>
			<SaveButton />
		</Toolbar>
	);
}

function PaletteColourEdit(props: EditProps) {
	return (
		<Edit {...props}>
			<SimpleForm toolbar={<EditToolbar />}>
				<TextField source="id" />
				<TextInput source="colour" validate={validateColour} />
				<TextInput
					source="symbolSvgContent"
					required={false}
					multiline
					minRows={5}
					helperText="WARNING: For developers only. Staff do not change"
					disabled
				/>
				<BooleanInput source="enabled" />
			</SimpleForm>
		</Edit>
	);
}

export { PaletteColourList, PaletteColourCreate, PaletteColourEdit };
